/**
 * Maps locale codes to language codes for i18n
 * @param {string} locale - Locale code (e.g., 'en-US', 'es-ES')
 * @returns {string} Language code (e.g., 'en', 'es')
 */
export function localeToLanguage(locale) {
  if (!locale || typeof locale !== 'string') {
    return 'en'; // Default to English
  }

  // Extract language code from locale (everything before the hyphen)
  const languageCode = locale.split('-')[0].toLowerCase();

  // Map of supported languages
  const supportedLanguages = ['en', 'es', 'fr', 'it', 'ko', 'zh', 'lt', 'yi', 'mr'];

  // Return language code if supported, otherwise default to English
  return supportedLanguages.includes(languageCode) ? languageCode : 'en';
}

/**
 * Common locale-to-language mappings for Spain and English regions
 */
export const LOCALE_LANGUAGE_MAP = {
  'es-ES': 'es', // Spain Spanish
  'es-MX': 'es', // Mexico Spanish
  'es-AR': 'es', // Argentina Spanish
  'en-US': 'en', // United States English
  'en-GB': 'en', // United Kingdom English
  'en-CA': 'en', // Canada English
  'fr-FR': 'fr', // France French
  'it-IT': 'it', // Italy Italian
  'ko-KR': 'ko', // Korea Korean
  'zh-CN': 'zh', // China Chinese
  'lt-LT': 'lt', // Lithuania Lithuanian
};
